var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('datetime',{class:_vm.classe,attrs:{"format":_vm.formato,"type":_vm.tipo,"auto":"","zone":"utc+3"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_vm._v(" "),(_vm.model !== '')?_c('span',{on:{"click":_vm.clear}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01cbb1da","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/date-time.vue
// module id = 777
// module chunks = 245